import { gql } from "@apollo/client";

export const session = gql`
  query OrgDomainSession ($token: String!, $domainId: String!) {
    viewer {
      id
      anonymous(token: $token) {
        auth {
          session(domainId: $domainId) {
            domain
            description
          }
        }
      }
    }
  }
`;
